import { createIcon } from "@chakra-ui/icons";

// Combines a building silhouette with a terrain/mountain silhouette to represent the
// "3D buildings and terrain" map mode.

export const BuildingsTerrainIcon = createIcon({
  displayName: "BuildingsTerrain",
  viewBox: "0 0 24 24",
  path: (
    <g>
      {/* Building */}
      <path
        d="M4 22V6L11 3V22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7 9H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 17H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Terrain peaks */}
      <path
        d="M11 22L16 12L19 17L21 13L23 22H11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
  ),
});
